<template>
  <div>
    <v-btn
      :title="itemIndex !== 8 ? navItem.value : 'הסוכנת החכמה'| strippedContent"
      :[link()]="itemIndex === total ? viewPage : navItem.link"
      class="'menu-items-border v-btn v-btn--text text hidden-sm-and-down'"
      :class="itemIndex !== total ? 'd-link' : ''"
      :prefetch="false"
       @click.native="fireGtmEvent(navItem.value)"
      :target="navItem.innerPage ? 'self' : '_blank' "
      text
    >
      <span class="d-nowrap">
        <span v-if="itemIndex === 8" v-html="'הסוכנת החכמה'"></span>
        <span
          v-else
          v-html="navItem.value"
        ></span>
        <!-- <span
          v-else
          v-html="navItem.value.replace('</br>', ' ')"
        ></span> -->
      </span>

      <span class="d-wrap">
        <span v-if="itemIndex === 8" v-html="'הסוכנת החכמה'"></span>
        <span v-else v-html="navItem.value"></span>
      </span>
      <span v-if="itemIndex === 3" class="new-agent">חדש</span>
    </v-btn>
  </div>
</template>

<script>
import CurrentUser from '@/components/mixins/CurrentUser';
import gtm from '@/lib/gtm';

export default {
  mixins: [CurrentUser],
  components: {},
  props: {
    navItem: {
      type: Object,
      default: () => ({ KeyValue: { Value: '' } })
    },
    itemIndex: {
      type: Number,
      default: null
    },
    total: {
      type: Number,
      default: null
    }
  },
  computed: {
    viewPage() {
      if (this.CurrentUser && this.NumberOfAgents.length > 0) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    }
  },
  methods: {
    link() {
      return this.navItem.innerPage ? 'to' : 'href';
    },

    fireGtmEvent(name) {
      gtm({
        name: 'main_bar',
        main_bar_name: name.replace('</br>', ' '),
        event: 'drushim_main_bar'
      });

      // gtm({
      //   category: 'הקלקה על משרות ללא קו"ח ',
      //   action: 'תפריט ראשי',
      //   event: 'משרות_ללא_קוח'
      // });

      // gtm({
      //   event_name: 'הקלקה על משרות ללא קו"ח ',
      //   place_click: 'תפריט ראשי',
      //   event: 'משרות_ללא_קוח_GA4'
      // });
    }
  }
};
</script>

<style lang="scss" scopd>
.v-toolbar__items {
  align-items: center;
}
.v-toolbar__content {
  justify-content: space-between;
}
.nav-items {
  margin: 0 auto;
}

.new-agent {
  display: flex;
  font-size: 12px;
  color: #fff;
  background-color: #0fca80;
  padding: 1px 4px;
  border-radius: 4px;
  margin-right: 9px;
}
#headerMenu .menu-item a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: right;

  color: #231f20;

  display: flex;
  align-items: center;
  padding: 0px 5px 0px 25px;

  &:hover {
    color: $primary;
  }
}
#headerMenu .menu-item .d-link .v-btn {
  border-radius: 0;
}
#headerMenu .menu-item:last-child a {
  background: transparent url('~assets/23/avatar.svg') right center no-repeat;
  background-size: 50px;
  line-height: 50px;
  padding: 0px 50px 0px 0px;
}

.user-menu {
  margin-top: 20px;
}
.d-nowrap {
  display: block;
}
.d-wrap {
  display: none;
}
@media screen and (max-width: 1640px) {
  #headerMenu .menu-item a {
    padding: 0px 0px 0px 15px;
  }
}

@media screen and (max-width: 1500px) {
}
@media screen and (max-width: 1480px) {
  #headerMenu .menu-item a {
    padding: 0px 0px 0px 30px;
  }
  .d-nowrap {
    display: none;
  }
  .d-wrap {
    display: block;
  }
}
@media screen and (max-width: 1280px) {
  #headerMenu .menu-item {
    display: none;
  }

  #headerMenu .menu-item:last-child a {
    background: #ff7100;
    color: #fff;
    line-height: 33px;
    padding: 0px 5px 0px 5px;
    font-size: 13px;
    text-align: center;
    flex-direction: row-reverse;
    background-size: 50px;
    align-items: center;
    margin-right: 4px;
    width: 98px;
    border-radius: 50px;
  }
}

@media screen and (max-width: 768px) {
  .nav-wrapper {
    padding: 2px 2px;
  }
}
@media screen and (max-width: 600px) {
  .v-toolbar__content {
    padding: 0 !important;
  }
}
</style>
